import { authScreenLabels } from '../../dictionnary';
import { candidateForSave, formatDateFromMillis } from '../../Utils';
import { useHookstate } from '@hookstate/core';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { useContext, useState, useEffect } from 'react';
import { StructureContext } from '../../structure-context';
import { saveGrilleEvaluation, getPdf } from '../../service/ApprentissageService';
import classNames from "classnames";
import { globalBlockedState } from '../../app-context';
import { createCanvas, loadImage } from "canvas";
import JsBarcode from "jsbarcode";

export const Grille = (parentProps) => {
    const [lng, setLng] = useState(parentProps.module.selectedGrille.language);
    const [module, setModule] = useState({ ...JSON.parse(JSON.stringify(parentProps.module)), draft: parentProps.module.draft === false ? false : true });
    const [canBeValidated, setCanBeValidated] = useState(true);
    const [displayValidation, setDisplayValidation] = useState(false);
    const blockedState = useHookstate(globalBlockedState);
    const structureContext = useContext(StructureContext);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, []);

    useEffect(() => {
        setCanBeValidated(candidateForSave());
    }, [module]);

    const updateCompetenceNote = (val, idx) => {
        module.selectedGrille.competences[idx].note = val;
        const needJustificatif = val === null ? false : module.selectedGrille.competences[idx].points / 2 > val;
        if (!needJustificatif) {
            module.selectedGrille.competences[idx].justificatif = null;
        }
        if (val || val === 0) {
            module.selectedGrille.competences[idx].notEvaluated = false;
        }
        module.selectedGrille.competences[idx].needJustificatif = needJustificatif;
        setModule({ ...module });
    }

    const signGrille = (val) => {
        module.evaluated = val;
        setModule({ ...module });
    }

    const afterSave = (draft, grilles, onError) => {
        blockedState.set(false);
        if (onError) {
            parentProps.showError('Error', onError.message);
        } else {
            parentProps.afterSave(draft, grilles);
        }
    }

    const saveDraft = () => {
        blockedState.set(true);
        module.draft = true;
        saveGrilleEvaluation(module, afterSave);
    }

    const validate = () => {
        if (!module.evaluated) {
            return;
        }

        setDisplayValidation(false);
        blockedState.set(true);
        module.draft = false;
        saveGrilleEvaluation(module, afterSave);
    }

    const updateCompetenceJustificatif = (val, idx) => {
        module.selectedGrille.competences[idx].justificatif = val;
        setModule({ ...module });
    }

    const updateJustificatifGlobal = (val) => {
        module.selectedGrille.justificatifGlobal = val;
        setModule({ ...module });
    }

    const updateModuleNotEvaluated = (checked) => {
        if (!checked) {
            module.selectedGrille.justificatifGlobal = null;
        } else {
            module.selectedGrille.competences.forEach((comp) => {
                comp.note = null;
                comp.needJustificatif = false;
                comp.justificatif = null;
                comp.notEvaluated = false;
            });
        }
        module.selectedGrille.notEvaluated = checked;
        setModule({ ...module });
    }

    const updateCompetenceNotEvaluated = (checked, idx) => {
        if (!checked) {
            module.selectedGrille.competences[idx].justificatif = null;
        }
        module.selectedGrille.competences[idx].notEvaluated = checked;
        setModule({ ...module });
    }

    const switchLng = () => {
        const newLng = lng === 'fr' ? 'de' : 'fr';
        const copyGrille = JSON.parse(JSON.stringify(module.grilles.find(g => g.language === newLng)));
        module.selectedGrille.competences.forEach((comp, idx) => {
            copyGrille.competences[idx].note = comp.note;
            copyGrille.competences[idx].needJustificatif = comp.needJustificatif;
            copyGrille.competences[idx].justificatif = comp.justificatif;
        });
        module.selectedGrille = copyGrille;
        setModule(module);
        setLng(newLng);
    }

    const renderFooter = () => {
        return (
            <div>
                <Button label="Valider" icon="pi pi-check" onClick={() => validate()} autoFocus disabled={!module.evaluated} />
            </div>
        );
    }

    const renderHeader = () => {
        return (<><i className="fas fa-signature"></i> {authScreenLabels[lng]["Signature"]}</>)
    }

    const generatePDF = () => {
        let envoi = 1;
        const dt = new Date();
        let mois = dt.getMonth();
        let annee = dt.getUTCFullYear();
        if (mois < 8) {
            annee--;

            if (mois > 1) {
                envoi = 2;
            }
        }

        let brcdStr = module.contratId + "-" + module.moduleId + "-" + annee + "-" + envoi;
        let canvas = createCanvas(20, 500);
        JsBarcode(canvas, brcdStr, {
            format: "code128",
            width: 1,
            height: 10,
            displayValue: false
        });
        let bcImageUrl = canvas.toDataURL();
        let ctx = canvas.getContext('2d');
        let newH = canvas.width;
        let newW = canvas.height;
        canvas.width = newW;
        canvas.height = newH;

        ctx.translate(0, newH);
        ctx.rotate(-90 * Math.PI / 180);

        loadImage(bcImageUrl).then((image) => {
            ctx.drawImage(image, 0, 0);
            getPdf(module, authScreenLabels[module.selectedGrille.language], structureContext.name, canvas.toDataURL());
        });

    }

    return (
        <>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12">
                <h5><div style={{ float: "right" }}>{!module.evaluated && module.grilles.length > 1 && (<span className={classNames("flag", "cdm-small-flag", {
                    "flag-fr": lng !== 'fr',
                    "flag-de": lng === 'fr',
                })} style={{ cursor: "pointer" }} onClick={switchLng}></span>)} <i className="fas fa-print" style={{ cursor: "pointer" }} onClick={generatePDF}></i></div>{module.apprenti} <div className="p-card-subtitle">{module.metier}<br />{module.diplome}</div></h5>
                <table>
                    <tbody>
                        <tr>
                            <td className="cdm-grille-header">{authScreenLabels[lng]["Tuteur"]} :</td>
                        </tr>
                        <tr><td className="cdm-grille-label">{module.tuteur}</td></tr>
                        <tr>
                            <td className="cdm-grille-header">{authScreenLabels[lng]["Unité capitalisable"]} :</td>
                        </tr>
                        <tr><td className="cdm-grille-label">{module.selectedGrille.uc}</td></tr>
                        <tr>
                            <td className="cdm-grille-header">{authScreenLabels[lng]["Module"]} : <span className="type-inscription-badge">{module.typeInscription}</span></td>
                        </tr>
                        <tr>
                            <td className="cdm-grille-label">{module.selectedGrille.name} ({module.selectedGrille.codeModule})</td>
                        </tr>
                        <tr>
                            <td className="cdm-grille-header">{authScreenLabels[lng]["Méthode(s) d'évaluation prescrite(s)"]}</td>
                        </tr>
                        <tr>
                            <td className="cdm-grille-label">{module.selectedGrille.evaluation}</td>
                        </tr>
                    </tbody>
                </table>

                {module.draft && (
                    <div><div><div className="p-message p-component p-message-warn p-message-enter-done"><div className="p-message-wrapper"><span className="p-message-icon pi pi-exclamation-triangle"></span><div className="p-ml-2">{authScreenLabels[lng]["Module warning"]}<br />{authScreenLabels[lng]["Competence warning"]}</div></div></div></div></div>
                )}

                {(!module.draft && (module.selectedGrille.justificatifGlobal || module.selectedGrille.competences.find(competence => !competence.note && competence.note !== 0 && competence.justificatif))) && (
                    <div><div><div className="p-message p-component p-message-warn p-message-enter-done"><div className="p-message-wrapper"><span className="p-message-icon pi pi-exclamation-triangle"></span><div className="p-ml-2">{authScreenLabels[lng]["Module non-évalué"]}</div></div></div></div></div>
                )}

                <p />
                {!module.selectedGrille.notEvaluated && (<>
                    {module.selectedGrille.competences.map((competence, idxComp) => {
                        return (
                            <React.Fragment key={`grilleCpt${idxComp}`}>
                                <table className="cdm-grille" cellSpacing="0" cellPadding="0">
                                    <thead>
                                        <tr>
                                            <th scope="col" className="cdm-grille-border-left cdm-grille-border-top">{authScreenLabels[lng]["Compétences"]}</th>
                                            <th scope="col" className="cdm-grille-border-left cdm-grille-border-top">{authScreenLabels[lng]["Indicateurs"]}</th>
                                            <th scope="col" className="cdm-grille-border-left cdm-grille-border-top">{authScreenLabels[lng]["Socles"]}</th>
                                            <th scope="col" className="cdm-grille-border-left cdm-grille-border-top cdm-grille-border-right">{authScreenLabels[lng]["Points acquis"]}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td data-label={authScreenLabels[lng]["Compétences"]} className="cdm-col-tiers cdm-grille-border-left cdm-grille-border-bottom"><b>{competence.label}</b></td>
                                            <td data-label={authScreenLabels[lng]["Indicateurs"]} className="cdm-col-tiers cdm-grille-border-left cdm-grille-border-bottom">{competence.indicator}</td>
                                            <td data-label={authScreenLabels[lng]["Socles"]} className="cdm-col-tiers cdm-grille-border-left cdm-grille-border-bottom">{competence.socle}</td>
                                            <td data-label={authScreenLabels[lng]["Points acquis"]} className="cdm-grille-border-left cdm-grille-border-right cdm-grille-border-bottom" style={{ textAlign: "center", paddingTop: "10px" }}>
                                                {(module.draft || (!module.draft && (competence.note || competence.note === 0))) && (<InputNumber disabled={!module.draft} mode="decimal" showButtons buttonLayout="vertical" style={{ width: '5rem' }} min={0} max={competence.points} suffix={` / ${competence.points}`} value={competence.note} onChange={(e) => updateCompetenceNote(e.value, idxComp)} onValueChange={(e) => updateCompetenceNote(e.value, idxComp)}
                                                    decrementButtonClassName={classNames("p-button-primary", "p-button-outlined", {
                                                        "cdm-hide": !module.draft,
                                                    })} incrementButtonClassName={classNames("p-button-success", "p-button-outlined", {
                                                        "cdm-hide": !module.draft,
                                                    })} incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" className={classNames({
                                                        "p-invalid": !competence.note && competence.note !== 0 && !competence.justificatif,
                                                    })} />)}
                                                {!module.draft && !competence.note && competence.note !== 0 && (<p style={{ color: "crimson" }}>N/A</p>)}
                                            </td>
                                        </tr>
                                        {(competence.needJustificatif || (!competence.note && competence.note !== 0)) && (<tr>
                                            <td colSpan="5" className="cdm-grille-border-left cdm-grille-border-bottom cdm-grille-border-right">
                                                {!competence.note && competence.note !== 0 && (<><Checkbox checked={competence.notEvaluated} disabled={!module.draft} onChange={e => updateCompetenceNotEvaluated(e.checked, idxComp)} /> <label>{authScreenLabels[lng]["Compétence non-évaluée"]}</label></>)}
                                                {(competence.note || competence.note === 0) && (<p style={{ fontWeight: "bold" }}>{authScreenLabels[lng]["Justification en cas de note insuffisante(< 50% des points max.)"]}</p>)}
                                                {(competence.needJustificatif || competence.notEvaluated) && (<InputTextarea placeholder={authScreenLabels[lng]["Justification"]} disabled={!module.draft} rows={5} autoResize onChange={(e) => updateCompetenceJustificatif(e.target.value, idxComp)} value={competence.justificatif || ""} className={classNames("cdm-justificatif-note", {
                                                    "cdm-field-error": !competence.justificatif,
                                                })} />)}
                                            </td>
                                        </tr>)}
                                        <tr>
                                            <td colSpan="5" className="cdm-grille-border-divider">&nbsp;</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </React.Fragment>
                        );
                    })
                    }</>)}

                {((module.draft && !module.selectedGrille.competences.find(competence => (competence.note || competence.note === 0))) || (!module.draft && module.selectedGrille.notEvaluated)) && (
                    <table className="cdm-grille" cellSpacing="0" cellPadding="0" width="100%">
                        <tbody>
                            <tr><td>
                                <p><Checkbox inputId="modne" checked={module.selectedGrille.notEvaluated} disabled={!module.draft} onChange={e => updateModuleNotEvaluated(e.checked)} /> <label htmlFor="modne">{authScreenLabels[lng]["Module non-évalué"]}</label></p></td></tr>
                            {module.selectedGrille.notEvaluated && (<tr><td>
                                <InputTextarea disabled={!module.draft} rows={5} placeholder={authScreenLabels[lng]["Justification en cas de module non-évalué"]} autoResize onChange={(e) => updateJustificatifGlobal(e.target.value)} value={module.selectedGrille.justificatifGlobal || ""} className={classNames("cdm-justificatif-note", {
                                    "cdm-field-error": !module.selectedGrille.justificatifGlobal,
                                })} />
                            </td>
                            </tr>)}
                        </tbody>
                    </table>
                )}
            </div>
            <div className="p-col-12 p-sm-12 p-md-12 p-lg-12" style={{ minHeight: "50px" }}>

                {module.draft && (<div className="cdm-group-button"><Button icon="pi pi-times" className="p-button-warning p-button-outlined cdm-button" label={authScreenLabels[lng]["Annuler"]} onClick={() => parentProps.handleCancel()} />
                    <Button icon="fab fa-firstdraft" className="p-button-primary p-button-outlined cdm-button" label={authScreenLabels[lng]["Brouillon"]} onClick={saveDraft} />
                    <Button icon="pi pi-check" className="p-button-success p-button-outlined cdm-button" label={authScreenLabels[lng]["Valider"]} disabled={!canBeValidated} onClick={() => setDisplayValidation(true)} /></div>)}
                {!module.draft && (<>
                    <div className="cdm-wrapper-sign" style={{ fontWeight: "500" }}><i className="fas fa-signature" style={{ paddingRight: "20px" }}></i>{authScreenLabels[lng]["ValidatedAndTransfered"]} {formatDateFromMillis(module.savedDate ? module.savedDate : Date.now())}
                    {authScreenLabels[lng]["byUser"]} {module.savedBy}</div>
                    <Button icon="pi pi-arrow-circle-left" className="p-button-primary p-button-outlined cdm-button" label={authScreenLabels[lng]["Retour"]} onClick={() => parentProps.handleCancel()} /></>)}

            </div>

            <Dialog header={renderHeader} visible={displayValidation} className="cdm-sign-dialog" onHide={() => { signGrille(false); setDisplayValidation(false) }} footer={renderFooter}>
                <table><tbody><tr><td style={{ verticalAlign: "top" }}><Checkbox onChange={e => signGrille(e.checked)} checked={module.evaluated}></Checkbox></td><td style={{ fontWeight: 500 }}>{authScreenLabels[lng]["AcceptAndSign"]}</td></tr></tbody></table>
            </Dialog>

        </>
    );

}